import type { Spread } from "../bdl/model";
import { Figure } from "./Figure";

/**
 * The chain's first beat, at the reference 375×667, as faithfully as the DOM
 * allows: the title, the figure moving, the line, the spoken body.
 */
export function Card({ spread, animate = true }: { spread: Spread; animate?: boolean }) {
  const first = spread.chain.beats[0];
  const fig = spread.figures[first?.figureId ?? spread.card.figureId];
  return (
    <div className="phone">
      <div className="title">{spread.card.title}</div>
      {fig && <Figure className="fig" figure={fig} size={333} animate={animate} />}
      <div className="hook">{first?.line || spread.card.hook}</div>
      <div className="prose"><p>{first?.body}</p></div>
    </div>
  );
}
